import {useEffect, useState} from "react";

import InfoBlock from "./InfoBlock";

export default function About() {
    const [toggledBlock, setToggledBlock] = useState(null);
    const infoBlocks = {
        "who-i-am": {
            title: "Who I Am",
            color: "green",
            isToggled: isToggled("who-i-am"),
            onToggle: (e) => toggle(e, "who-i-am"),
            onCollapse: (e) => toggle(e, null),
            className: "about__grid-1",
            children: <article>
                <p>
                    I am a Web Design & Development graduate from Edge Hill University, with a passion for application
                    development across multiple platforms such as mobile, web and desktop. I am looking for a graduate
                    role
                    where I can apply this passion to continue my development journey. I am a confident developer across
                    multiple languages such as python, Java and PHP and I am experienced with databases. Examples of my
                    work
                    and projects are available on my GitHub page.
                </p>
                <br/>
                <p>
                    I have been building my development experience over the last 7+ years. I enjoy working as part of a
                    team and I have often been chosen as a team leader for projects during my time at university. I am
                    also able to work independently, being self-motivated and I love to see things through to
                    completion. I graduated with a first-class degree having achieved a grade of 82% for my final year
                    dissertation and an average of 83% over the three years I was a student.
                </p>
            </article>
        },
        "what-i-do": {
            title: "What I Do",
            color: "purple",
            isToggled: isToggled("what-i-do"),
            onToggle: (e) => toggle(e, "what-i-do"),
            onCollapse: (e) => toggle(e, null),
            className: "about__grid-2 animation--duration-1500ms",
            children: [
                <p>
                    I pride myself on knowing multiple programming languages in multiple areas of computer science. From
                    full stack web development to cross-platform mobile development as well as game development and
                    software application development. I am also experienced with git for version control. I have good
                    experience in database design & development, and I am familiar with utilizing Figma and Adobe XD to
                    create designs & wireframe prototypes. I love spending time learning and enhancing my programming
                    skills keeping as up to date as I can with advances in computer science.
                </p>,
                <div className="my-skills">
                    <i className="fab fa-php my-skills__skill">
                        <span>PHP</span>
                    </i>
                    <i className="fab fa-html5 my-skills__skill">
                        <span>HTML</span>
                    </i>
                    <i className="fab fa-css3 my-skills__skill">
                        <span>CSS</span>
                    </i>
                    <i className="fab fa-node-js my-skills__skill">
                        <span>Node.js</span>
                    </i>
                    <i className="fab fa-angular my-skills__skill">
                        <span>Angular</span>
                    </i>
                    <i className="fab fa-react my-skills__skill">
                        <span>React</span>
                    </i>
                    <i className="fab fa-vuejs my-skills__skill">
                        <span>Vue</span>
                    </i>
                    <i className="fab fa-figma my-skills__skill">
                        <span>Figma</span>
                    </i>
                    <i className="fab fa-python my-skills__skill">
                        <span>Python</span>
                    </i>
                    <i className="fab fa-java my-skills__skill">
                        <span>Java</span>
                    </i>
                    <i className="fab fa-unity my-skills__skill">
                        <span>Unity</span>
                    </i>
                    <i className="fas fa-database my-skills__skill">
                        <span>SQL</span>
                    </i>
                </div>
            ]
        },
        "know-me": {
            title: "Know Me",
            color: "orange",
            isToggled: isToggled("know-me"),
            onToggle: (e) => toggle(e, "know-me"),
            onCollapse: (e) => toggle(e, null),
            className: "about__grid-3 animation--duration-1750ms",
            children: <p>
                Apart from being a keen programmer in my spare time I am a keen football fan supporting Queens Park
                Rangers whilst also playing football when I can. I serve in my church weekly helping them utilize
                technology to the best of my ability (aka Sound and tech/live streaming). I am also a keen gamer and
                enjoy PC gaming when I can.
            </p>
        }
    };

    useEffect(() => {
        document.body.onclick = () => setToggledBlock(null);
    });

    const [displayOtherBlocks, setDisplayOtherBlocks] = useState({previouslyActive: null, display: true});

    useEffect(() => {
        if (toggledBlock === null) {
            setTimeout(() => setDisplayOtherBlocks({previouslyActive: null, display: true}), 500);
        } else {
            setDisplayOtherBlocks({previouslyActive: toggledBlock, display: false});

            let el = document.getElementById("about-me");
            let scrollTo = el.getBoundingClientRect().top + window.pageYOffset - 75;

            window.scrollTo({top: scrollTo, behavior: "smooth"});
        }
    }, [toggledBlock]);

    function toggle(e, value) {
        e.stopPropagation();
        setToggledBlock(value);
    }

    function isToggled(value) {
        return toggledBlock === null ? null : toggledBlock === value;
    }

    function flexDirection() {
        switch (displayOtherBlocks.previouslyActive) {
            case "who-i-am":
                return "flex-start";
            case "what-i-do":
            default:
                return "center";
            case "know-me":
                return "flex-end";
        }
    }

    return (
        <>
            <h1 className="title">
                About Me
                <div className="title__underline"/>
            </h1>

            <div className="about" id="about-me" style={{"justify-content": flexDirection()}}>
                {["who-i-am", "what-i-do", "know-me"].map(block =>
                    (
                        (toggledBlock === block || displayOtherBlocks.previouslyActive === block) ||
                        displayOtherBlocks.display
                    ) && <InfoBlock {...infoBlocks[block]} />
                )}
            </div>
        </>
    );
}
